module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Warrior.5ffc2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Warrior.jpg
// module id = D0mo
// module chunks = 0